export default __webpack_public_path__ + "static/kit-nosotras-CO-a76e63b738fa15fc7474fab190600de6.png";